module.exports = __webpack_public_path__ + "img/name.53e134e5.png";